import type { Gender, SignInPayload, SignOutPayload, SignType } from './gtm.types';

// /api/users/me 응답의 가용 필드.
// libs/types 의 AuthUserType / UserType 에 일부 필드가 명시되지 않아 여기서 확장 정의한다.
// 실측 결과(통합 검증 단계)에 따라 키 이름을 보정할 것.
export type AuthMeResponse = {
  id?: number;
  email?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  snsType?: string | null;
  gender?: string | null;
  birthDate?: string | null;
  marketingEmailAgreed?: boolean;
  marketingSmsAgreed?: boolean;
  [k: string]: unknown;
};

export function normalizeSignType(snsType: string | null | undefined): SignType {
  if (!snsType) return 'email';
  const v = snsType.toLowerCase();
  if (
    v === 'google' ||
    v === 'kakao' ||
    v === 'naver' ||
    v === 'cafe24' ||
    v === 'smartstore' ||
    v === 'shopby'
  ) {
    return v;
  }
  return 'email';
}

export function normalizeGender(raw: string | null | undefined): Gender | null {
  if (!raw) return null;
  const v = raw.toLowerCase();
  if (v === 'm' || v === 'male') return 'male';
  if (v === 'f' || v === 'female') return 'female';
  return null;
}

// 'YYYYMMDD' 또는 'YYYY-MM-DD' 형식을 'YYYY-MM-DD' 로 정규화한다.
export function normalizeBirthDate(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const compact = /^(\d{4})(\d{2})(\d{2})$/.exec(raw);
  if (compact) return `${compact[1]}-${compact[2]}-${compact[3]}`;
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) return raw.slice(0, 10);
  return null;
}

export function composeName(user: AuthMeResponse): string {
  const fn = (user.firstName ?? '').trim();
  const ln = (user.lastName ?? '').trim();
  const composed = `${ln}${fn}`.trim();
  if (composed) return composed;
  return (user.username ?? '').trim();
}

export function buildSignInPayloadFromUser(user: AuthMeResponse): SignInPayload {
  return {
    member_id: user.id ?? null,
    member_sign_type: normalizeSignType(user.snsType),
    member_name: composeName(user),
    member_email: user.email ?? '',
    member_mobile: user.phone ?? null,
    member_gender: normalizeGender(user.gender),
    member_birthday: normalizeBirthDate(user.birthDate),
    member_email_agree: !!user.marketingEmailAgreed,
    member_sms_agree: !!user.marketingSmsAgreed,
  };
}

export function buildSignOutPayload(
  user: AuthMeResponse | null | undefined,
): SignOutPayload {
  return { member_id: user?.id ?? null };
}
